//---------------------------------------------------Umaya---------------------------------------------------

// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import UserPageHeader from '../components/UserPageHeader';
// import axios from 'axios';

// const DetailPage = () => {
//   const location = useLocation();
//   const { selectedCar } = location.state || {};
//   const [bookingSuccess, setBookingSuccess] = useState(false);
//   const [agreeMarketing, setAgreeMarketing] = useState(false);
// const [agreeTerms, setAgreeTerms] = useState(false);

//   const [showBookingForm, setShowBookingForm] = useState(false);
//   const [currentForm, setCurrentForm] = useState(1);
//   const [errors, setErrors] = useState({});
//   const [bookingDetails, setBookingDetails] = useState({
//     name: '',
//     phoneNumber: '',
//     address: '',
//     townCity: '',
//     pickupLocation: '',
//     pickupDate: '',
//     pickupTime: '',
//     dropoffLocation: '',
//     dropoffDate: '',
//     dropoffTime: '',

//     CarId: selectedCar?.id || '',
//     CarName: selectedCar?.name || '',
//     CarManufacturer: selectedCar?.manufacturer?.name || '',
//     CarType: selectedCar?.type || '',
//     CarCapacity: selectedCar?.capacity || '',
//     CarPerDay: selectedCar?.perday || '',
//   });

//   const validateForm = () => {
//     const newErrors = {};
//     if (currentForm === 1) {
//       if (!bookingDetails.name.trim()) newErrors.name = 'Name is required';
//       if (!bookingDetails.phoneNumber.trim()) {
//         newErrors.phoneNumber = 'Phone number is required';
//       } else if (!/^\d{10}$/.test(bookingDetails.phoneNumber)) {
//         newErrors.phoneNumber = 'Phone number must be 10 digits';
//       }
//       if (!bookingDetails.address.trim()) newErrors.address = 'Address is required';
//       if (!bookingDetails.townCity.trim()) newErrors.townCity = 'Town/City is required';
//     }

//     if (currentForm === 2) {
//       if (!bookingDetails.pickupLocation.trim()) newErrors.pickupLocation = 'Pickup location is required';
//       if (!bookingDetails.pickupDate) newErrors.pickupDate = 'Pickup date is required';
//       if (!bookingDetails.pickupTime) newErrors.pickupTime = 'Pickup time is required';
//       if (!bookingDetails.dropoffLocation.trim()) newErrors.dropoffLocation = 'Dropoff location is required';
//       if (!bookingDetails.dropoffDate) newErrors.dropoffDate = 'Dropoff date is required';
//       if (!bookingDetails.dropoffTime) newErrors.dropoffTime = 'Dropoff time is required';

//       if (bookingDetails.pickupDate && bookingDetails.dropoffDate &&
//         new Date(bookingDetails.dropoffDate) < new Date(bookingDetails.pickupDate)
//       ) {
//         newErrors.dropoffDate = 'Dropoff date cannot be before pickup date';
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNext = () => {
//     if (validateForm()) {
//       if (currentForm < 3) setCurrentForm(currentForm + 1);
//     }
//   };
//   const handlePrevious = () => {
//     if (currentForm === 1) {
//       setShowBookingForm(false); // Return to car details
//     } else {
//       setCurrentForm(currentForm - 1);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setBookingDetails((prevDetails) => ({
//       ...prevDetails,
//       [name]: value,
//     }));
//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!agreeMarketing || !agreeTerms) {
//     alert('Please agree to both checkboxes before proceeding.');
//     return;
//   }

//   try {
//     await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Bookings',
//       { ...bookingDetails, status: 'Pending' },
//       { headers: { 'Content-Type': 'application/json' } }
//     );

//     alert('Booking request sent. Waiting for admin approval.');
//     setBookingSuccess(true);
//     setCurrentForm(4);  // Move to step 4 after success

//   } catch (error) {
//     console.error('Error submitting data:', error.response?.data || error.message);
//     alert('Error submitting booking request.');
//   }
// };

//   return (
//     <div className="bg-gray-100 min-h-screen">
//       <UserPageHeader />

//       <div className="max-w-6xl mx-auto px-4 py-10 mt-10">
//   {/* Car Details Section (Hide when booking starts) */}
//   {!showBookingForm && (
//     <div className="grid md:grid-cols-2 gap-8 bg-white p-6 rounded-lg shadow-md mt-10">
//       {/* Left - Car Image */}
//       <div>
//         <div className="bg-blue-500 text-white p-6 rounded-lg relative">
//           <h2 className="text-xl font-semibold">Sports car with the best design and acceleration</h2>
//           <p className="mt-2 text-sm">Safety and comfort while driving a futuristic and elegant sports car</p>
//           <div className="mt-4 w-full h-64 overflow-hidden rounded-md relative">
//             <img
//               src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${selectedCar?.id}`}
//               alt={selectedCar?.name}
//               className="object-cover w-full h-full absolute top-0 left-0"
//             />
//           </div>
//         </div>
//       </div>

//             <div>

//           <div>
//             <h2 className="text-xl font-bold">{selectedCar?.name}</h2>
//             <p className="text-gray-500 text-sm">{selectedCar?.manufacturer?.name}</p>
//             <div className="flex items-center mt-2">
//               <span className="text-yellow-500">★★★★☆</span>
//               <p className="ml-2 text-sm text-gray-600">440+ Reviews</p>
//             </div>

//             <p className="mt-4 text-gray-700">{selectedCar?.description}</p>

//             {/* Car Specifications */}
//             <div className="grid grid-cols-2 gap-4 mt-4 text-sm">
//               <p><span className="font-semibold">Type:</span> {selectedCar?.type}</p>
//               <p><span className="font-semibold">Capacity:</span> {selectedCar?.capacity} Person</p>
//               <p><span className="font-semibold">Steering:</span> {selectedCar?.steering}</p>
//               <p><span className="font-semibold">Gasoline:</span>{selectedCar?.gasoline}</p>
//             </div>

//             {/* Pricing */}
//             <div className="mt-6">
//               <p className="text-2xl font-semibold text-blue-600">{selectedCar?.perDay}/day</p>
//               <p className="text-gray-400 line-through"></p>
//             </div>

//               <button
//                 onClick={() => setShowBookingForm(true)}
//                 className="mt-6 w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//               >
//                 Book Now
//               </button>
//             </div>
//           </div>
//           </div>
//         )}

//         {/* Booking Form Section (Show when booking starts) */}
//         {showBookingForm && (
//   <div className="bg-white p-6 rounded-lg shadow-md mt-8 w-full max-w-4xl mx-auto">
//     {/* Header with Right-Aligned Step Indicator */}
//     <div className="mb-6 flex justify-between items-center">
//       <div>
//         <h2 className="text-xl font-bold">
//           {currentForm === 1 ? 'Billing Info' : currentForm === 2 ? 'Booking Details' : 'Summary'}
//         </h2>
//         <p className="text-gray-500 text-sm">
//           {currentForm === 1 ? 'Please enter your billing info' : currentForm === 2 ? 'Enter your booking details' : 'Review your booking'}
//         </p>
//       </div>
//       {/* Right-Aligned Step Text */}
//       <span className="text-gray-400 text-sm">Step {currentForm} of 4</span>
//     </div>

//             {/* Step 1 */}
//             {currentForm === 1 && (
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {['name', 'phoneNumber', 'address', 'townCity'].map((field, idx) => (
//                   <div key={idx}>
//                     <label className="block text-sm text-gray-600 mb-1 capitalize">{field.replace(/([A-Z])/g, ' $1')}</label>
//                     <input
//                       type="text"
//                       name={field}
//                       value={bookingDetails[field]}
//                       onChange={handleInputChange}
//                       className="border p-2 rounded w-full bg-gray-100"
//                     />
//                     {errors[field] && <p className="text-red-500 text-sm">{errors[field]}</p>}
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Step 2 */}
//             {currentForm === 2 && (
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {[
//                   { name: 'pickupLocation', type: 'text' },
//                   { name: 'pickupDate', type: 'date' },
//                   { name: 'pickupTime', type: 'time' },
//                   { name: 'dropoffLocation', type: 'text' },
//                   { name: 'dropoffDate', type: 'date' },
//                   { name: 'dropoffTime', type: 'time' },
//                 ].map(({ name, type }, idx) => (
//                   <div key={idx}>
//                     <label className="block text-sm text-gray-600 mb-1 capitalize">{name.replace(/([A-Z])/g, ' $1')}</label>
//                     <input
//                       type={type}
//                       name={name}
//                       value={bookingDetails[name]}
//                       onChange={handleInputChange}
//                       className="border p-2 rounded w-full bg-gray-100"
//                     />
//                     {errors[name] && <p className="text-red-500 text-sm">{errors[name]}</p>}
//                   </div>
//                 ))}
//               </div>
//             )}

//            {/* Step 3: Summary */}
// {currentForm === 3 && (
//   <div className="bg-white p-6 rounded-lg shadow-md">
//     {/* Title */}
//     <h2 className="text-xl font-bold mb-2">Confirmation</h2>
//     <p className="text-gray-500 text-sm mb-4">
//       We are getting to the end. Just a few clicks and your rental is ready!
//     </p>

//     <div className="space-y-3">

//       <label className="flex items-start space-x-2 bg-gray-100 p-3 rounded-lg">
//   <input
//     type="checkbox"
//     className="mt-1"
//     checked={agreeMarketing}
//     onChange={(e) => setAgreeMarketing(e.target.checked)}
//   />
//   <span className="text-sm text-gray-700">
//     I agree with sending marketing and newsletter emails. No spam, promised!
//   </span>
// </label>

// <label className="flex items-start space-x-2 bg-gray-100 p-3 rounded-lg">
//   <input
//     type="checkbox"
//     className="mt-1"
//     checked={agreeTerms}
//     onChange={(e) => setAgreeTerms(e.target.checked)}
//   />
//   <span className="text-sm text-gray-700">
//     I agree with our terms and conditions and privacy policy.
//   </span>
// </label>

//     </div>

//     {/* Rent Now Button */}
//     <button  onClick={handleSubmit} className="mt-6 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
//       Rent Now
//     </button>

//     {/* Security Info */}
//     <div className="flex items-center space-x-2 mt-6">
//       <span className="text-blue-600">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           className="h-6 w-6"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m-3-7a9 9 0 11-9 9 9 9 0 019-9z" />
//         </svg>
//       </span>
//       <div>
//         <p className="font-medium text-gray-700">All your data is safe</p>
//         <p className="text-sm text-gray-500">
//           We use the most advanced security to provide you the best experience ever.
//         </p>
//       </div>
//     </div>
//   </div>
// )}

// {currentForm === 4 && bookingSuccess && (
//   <div className="bg-white p-6 rounded-lg shadow-md text-center">
//     <div className="flex justify-center">
//       <span className="bg-green-500 text-white p-4 rounded-full">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//         </svg>
//       </span>
//     </div>

//     <h2 className="text-xl font-bold mt-4">Booking Confirmed!</h2>
//     <p className="text-gray-500 mt-2">Your car rental has been successfully booked. You will receive a confirmation soon.</p>

//     <button
//       onClick={() => window.location.href = '/userpage'}
//       className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
//     >
//       Go to Home
//     </button>
//   </div>
// )}

// {/* Navigation Buttons */}
// <div className="mt-4 flex justify-between">
//   {currentForm !== 4 && (
//     <button onClick={handlePrevious} className="bg-gray-300 px-4 py-2 rounded">
//       Previous
//     </button>
//   )}
//   {currentForm < 3 && (
//     <button onClick={handleNext} className="bg-blue-600 text-white px-4 py-2 rounded">
//       Next
//     </button>
//   )}

// </div>

//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DetailPage;

//----------------------------------------------------Sachith---------------------------------------------------

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserPageHeader from "../components/UserPageHeader";
import axios from "axios";
import Swal from "sweetalert2";

const DetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedCar } = location.state || {};
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [currentForm, setCurrentForm] = useState(1);
  const [errors, setErrors] = useState({});

  const calculateTotalPrice = () => {
    if (!bookingDetails.pickupDate || !bookingDetails.dropoffDate) {
      return selectedCar?.perDay || 0;
    }

    const pickupDate = new Date(bookingDetails.pickupDate);
    const dropoffDate = new Date(bookingDetails.dropoffDate);
    
    // Calculate the difference in milliseconds
    const diffTime = Math.abs(dropoffDate - pickupDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Add 1 to include both pickup and dropoff days
    
    return (selectedCar?.perDay * diffDays) || 0;
  };

  const [bookingDetails, setBookingDetails] = useState({
    name: "",
    phoneNumber: "",
    address: "",
    townCity: "",
    pickupLocation: "",
    pickupDate: "",
    pickupTime: "",
    dropoffLocation: "",
    dropoffDate: "",
    dropoffTime: "",
    CarId: selectedCar?.id || "",
    CarName: selectedCar?.name || "",
    CarManufacturer: selectedCar?.manufacturer?.name || "",
    CarType: selectedCar?.type || "",
    CarCapacity: selectedCar?.capacity || "",
    CarPerDay: selectedCar?.perday || "",
  });

  const validateForm = () => {
    const newErrors = {};
    if (currentForm === 1) {
      if (!bookingDetails.name.trim()) newErrors.name = "Name is required";
      if (!bookingDetails.phoneNumber.trim()) {
        newErrors.phoneNumber = "Phone number is required";
      } else if (!/^\d{10}$/.test(bookingDetails.phoneNumber)) {
        newErrors.phoneNumber = "Phone number must be 10 digits";
      }
      if (!bookingDetails.address.trim())
        newErrors.address = "Address is required";
      if (!bookingDetails.townCity.trim())
        newErrors.townCity = "Town/City is required";
    }

    if (currentForm === 2) {
      if (!bookingDetails.pickupLocation.trim())
        newErrors.pickupLocation = "Pickup location is required";
      if (!bookingDetails.pickupDate)
        newErrors.pickupDate = "Pickup date is required";
      if (!bookingDetails.pickupTime)
        newErrors.pickupTime = "Pickup time is required";
      if (!bookingDetails.dropoffLocation.trim())
        newErrors.dropoffLocation = "Dropoff location is required";
      if (!bookingDetails.dropoffDate)
        newErrors.dropoffDate = "Dropoff date is required";
      if (!bookingDetails.dropoffTime)
        newErrors.dropoffTime = "Dropoff time is required";

      if (
        bookingDetails.pickupDate &&
        bookingDetails.dropoffDate &&
        new Date(bookingDetails.dropoffDate) <
          new Date(bookingDetails.pickupDate)
      ) {
        newErrors.dropoffDate = "Dropoff date cannot be before pickup date";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      if (currentForm < 3) setCurrentForm(currentForm + 1);
    }
  };

  const handlePrevious = () => {
    if (currentForm === 1) {
      setShowBookingForm(false);
    } else {
      setCurrentForm(currentForm - 1);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBookingDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreeMarketing || !agreeTerms) {
      Swal.fire({
        icon: "warning",
        title: "Agreement Required",
        text: "Please agree to both checkboxes before proceeding.",
      });
      return;
    }

    try {
      await axios.post(
        "https://carrentalbackend.dockyardsoftware.com/api/Bookings",
        { ...bookingDetails, status: "Pending" },
        { headers: { "Content-Type": "application/json" } }
      );

      Swal.fire({
        icon: "success",
        title: "Booking Request Sent",
        text: "Waiting for admin approval.",
      });

      setBookingSuccess(true);
      setCurrentForm(4);
    } catch (error) {
      console.error(
        "Error submitting data:",
        error.response?.data || error.message
      );

      Swal.fire({
        icon: "error",
        title: "Sorry",
        text: "Someone else has ordered",
      });
    }
  };

  // Prevent default behavior for terms and policy links
  const handleLinkClick = (e) => {
    e.preventDefault();
    // You can add modal or page navigation here if needed
    Swal.fire({
      icon: 'info',
      title: 'Document Not Available',
      text: 'The terms and conditions or privacy policy document is not available at the moment.',
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <UserPageHeader />
      <main className="pt-20 pb-10">
        <div className="max-w-10xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Car Details Section */}
          {!showBookingForm && (
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl">
              <div className="md:flex h-full">
                {/* Car Image Section - Improved */}
                <div className="md:w-1/2 relative">
                  <div className="h-full w-full bg-gradient-to-br from-indigo-900 to-blue-800 p-8 text-white flex flex-col">
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-0"></div>
                    <div className="relative z-10 flex flex-col h-full">
                      <div className="mb-6">
                        <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-2">
                          {selectedCar?.type}
                        </span>
                        <h2 className="text-3xl font-bold tracking-tight">
                          {selectedCar?.name}
                        </h2>
                        <p className="text-blue-200 mt-1 font-light">
                          {selectedCar?.manufacturer?.name}
                        </p>
                      </div>
                      <div className="mt-4 flex items-center">
                        <div className="flex text-amber-400">
                          {[...Array(5)].map((_, i) => (
                            <svg
                              key={i}
                              className="w-5 h-5 fill-current"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          ))}
                        </div>
                        <span className="ml-2 text-blue-200">440+ Reviews</span>
                      </div>
                      <div className="mt-auto flex-grow flex items-center justify-center">
                        <div className="relative w-full h-96 rounded-xl overflow-hidden shadow-2xl">
                          <img
                            src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${selectedCar?.id}`}
                            alt={selectedCar?.name}
                            className="absolute inset-0 w-full h-full object-contain transition-transform duration-500 hover:scale-105"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "https://via.placeholder.com/600x400?text=Car+Image";
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Car Info Section - Modernized */}
                <div className="md:w-1/2 p-8 flex flex-col">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-gray-900 text-2xl font-bold">
                        {selectedCar?.name}
                      </h3>
                      <p className="mt-1 text-gray-500">
                        {selectedCar?.manufacturer?.name}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="text-gray-400 line-through text-sm">
                      Rs.  {(selectedCar?.perDay * 1.2 ).toFixed(2)}
                      </p>
                      <p className="text-indigo-600 text-3xl font-bold">
                      Rs.  {selectedCar?.perDay}
                        <span className="text-gray-500 text-sm font-normal">
                          /day
                        </span>
                      </p>
                    </div>
                  </div>

                  <p className="mt-4 text-gray-600 leading-relaxed">
                    {selectedCar?.description}
                  </p>

                  {/* Specifications Grid - Modernized */}
                  <div className="mt-8 grid grid-cols-2 gap-4">
                    {[
                      {
                        icon: (
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                            />
                          </svg>
                        ),
                        title: "Capacity",
                        value: `${selectedCar?.capacity} Person`,
                      },
                      {
                        icon: (
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                            />
                          </svg>
                        ),
                        title: "Steering",
                        value: selectedCar?.steering,
                      },
                      {
                        icon: (
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                            />
                          </svg>
                        ),
                        title: "Gasoline",
                        value: `${selectedCar?.gasoline}L`,
                      },
                      {
                        icon: (
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                        ),
                        title: "Acceleration",
                        value: "0-100km in 4.2s",
                      },
                    ].map((spec, index) => (
                      <div
                        key={index}
                        className="flex items-start p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                      >
                        <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                          {spec.icon}
                        </div>
                        <div>
                          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {spec.title}
                          </p>
                          <p className="font-medium text-gray-900">
                            {spec.value}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-auto pt-6">
                    <button
                      onClick={() => setShowBookingForm(true)}
                      className="w-full bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white py-3 rounded-xl font-medium transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl flex items-center justify-center"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Booking Form Section - Modernized */}
          {showBookingForm && (
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              {/* Progress Steps - Modernized */}
              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 px-8 py-6 border-b">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                  <h2 className="text-2xl font-bold text-gray-900">
                    {currentForm === 1
                      ? "Billing Information"
                      : currentForm === 2
                      ? "Rental Details"
                      : currentForm === 3
                      ? "Confirmation"
                      : "Booking Complete"}
                  </h2>
                  <div className="mt-3 md:mt-0 flex items-center">
                    <span className="text-sm text-gray-600 mr-3">
                      Step {currentForm} of 4
                    </span>
                    <div className="flex space-x-2">
                      {[1, 2, 3, 4].map((step) => (
                        <div
                          key={step}
                          className={`h-2 w-8 rounded-full transition-all duration-300 ${
                            currentForm >= step
                              ? "bg-indigo-600"
                              : "bg-gray-300"
                          }`}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-8">
                {/* Step 1: Billing Info - Modernized */}
                {currentForm === 1 && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                      {
                        label: "Full Name",
                        name: "name",
                        type: "text",
                        placeholder: "John Doe",
                        icon: (
                          <svg
                            className="w-5 h-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        ),
                      },
                      {
                        label: "Phone Number",
                        name: "phoneNumber",
                        type: "tel",
                        placeholder: "1234567890",
                        icon: (
                          <svg
                            className="w-5 h-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                          </svg>
                        ),
                      },
                      {
                        label: "Address",
                        name: "address",
                        type: "text",
                        placeholder: "123 Main St",
                        colSpan: "md:col-span-2",
                        icon: (
                          <svg
                            className="w-5 h-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                        ),
                      },
                      {
                        label: "Town/City",
                        name: "townCity",
                        type: "text",
                        placeholder: "New York",
                        icon: (
                          <svg
                            className="w-5 h-5 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                        ),
                      },
                    ].map((field) => (
                      <div key={field.name} className={field.colSpan || ""}>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {field.label}
                          <span className="text-red-500 ml-1">*</span>
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            {field.icon}
                          </div>
                          <input
                            type={field.type}
                            name={field.name}
                            value={bookingDetails[field.name]}
                            onChange={handleInputChange}
                            placeholder={field.placeholder}
                            className={`w-full pl-10 pr-4 py-3 border ${
                              errors[field.name]
                                ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                : "border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
                            } rounded-lg focus:ring-2 focus:outline-none transition`}
                          />
                          {errors[field.name] && (
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <svg
                                className="h-5 w-5 text-red-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                        {errors[field.name] && (
                          <p className="mt-2 text-sm text-red-600">
                            {errors[field.name]}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Step 2: Booking Details - Modernized */}
                {currentForm === 2 && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-xl border border-indigo-100">
                        <h3 className="text-lg font-semibold text-indigo-800 mb-4 flex items-center">
                          <svg
                            className="w-5 h-5 mr-2 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          Pickup Details
                        </h3>
                        {[
                          {
                            label: "Pickup Location",
                            name: "pickupLocation",
                            type: "text",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                              </svg>
                            ),
                          },
                          {
                            label: "Pickup Date",
                            name: "pickupDate",
                            type: "date",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                            ),
                          },
                          {
                            label: "Pickup Time",
                            name: "pickupTime",
                            type: "time",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            ),
                          },
                        ].map((field) => (
                          <div key={field.name} className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              {field.label}
                              <span className="text-red-500 ml-1">*</span>
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                {field.icon}
                              </div>
                              <input
                                type={field.type}
                                name={field.name}
                                value={bookingDetails[field.name]}
                                onChange={handleInputChange}
                                className={`w-full pl-10 pr-4 py-2.5 border ${
                                  errors[field.name]
                                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                    : "border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
                                } rounded-lg focus:ring-2 focus:outline-none transition`}
                              />
                            </div>
                            {errors[field.name] && (
                              <p className="mt-2 text-sm text-red-600">
                                {errors[field.name]}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-xl border border-indigo-100">
                        <h3 className="text-lg font-semibold text-indigo-800 mb-4 flex items-center">
                          <svg
                            className="w-5 h-5 mr-2 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          Dropoff Details
                        </h3>
                        {[
                          {
                            label: "Dropoff Location",
                            name: "dropoffLocation",
                            type: "text",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 11111.314 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                              </svg>
                            ),
                          },
                          {
                            label: "Dropoff Date",
                            name: "dropoffDate",
                            type: "date",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                            ),
                          },
                          {
                            label: "Dropoff Time",
                            name: "dropoffTime",
                            type: "time",
                            icon: (
                              <svg
                                className="w-5 h-5 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            ),
                          },
                        ].map((field) => (
                          <div key={field.name} className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              {field.label}
                              <span className="text-red-500 ml-1">*</span>
                            </label>
                            <div className="relative">
                              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                {field.icon}
                              </div>
                              <input
                                type={field.type}
                                name={field.name}
                                value={bookingDetails[field.name]}
                                onChange={handleInputChange}
                                className={`w-full pl-10 pr-4 py-2.5 border ${
                                  errors[field.name]
                                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                    : "border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
                                } rounded-lg focus:ring-2 focus:outline-none transition`}
                              />
                            </div>
                            {errors[field.name] && (
                              <p className="mt-2 text-sm text-red-600">
                                {errors[field.name]}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Step 3: Confirmation - Modernized */}
                {currentForm === 3 && (
                  <div>
                    <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm">
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">
                        Final Confirmation
                      </h2>
                      <p className="text-gray-500 mb-8">
                        We are getting to the end. Just a few clicks and your
                        rental is ready!
                      </p>

                      {/* Summary Card - Modernized */}
                      <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-6 mb-8 border border-indigo-100">
                        <h3 className="font-semibold text-indigo-800 text-lg mb-4">
                          Booking Summary
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="bg-white p-4 rounded-lg shadow-sm">
                            <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
                              Vehicle
                            </h4>
                            <div className="flex items-center">
                              <div className="w-16 h-16 rounded-md overflow-hidden mr-4">
                                <img
                                  src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${selectedCar?.id}`}
                                  alt={selectedCar?.name}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                              <div>
                                <p className="font-semibold">
                                  {selectedCar?.name}
                                </p>
                                <p className="text-sm text-gray-500">
                                  {selectedCar?.manufacturer?.name}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="bg-white p-4 rounded-lg shadow-sm">
                            <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
                              Rental Period
                            </h4>
                            <div className="space-y-2">
                              <div className="flex items-center">
                                <svg
                                  className="w-4 h-4 text-indigo-500 mr-2"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                  />
                                </svg>
                                <span className="font-medium">
                                  {new Date(bookingDetails.pickupDate).toISOString().split("T")[0]} at {bookingDetails.pickupTime}
                                </span>
                              </div>
                              <div className="flex items-center">
                                <svg
                                  className="w-4 h-4 text-indigo-500 mr-2"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                  />
                                </svg>
                                <span className="font-medium">
                                 {new Date(bookingDetails.dropoffDate).toISOString().split("T")[0]} at {bookingDetails.dropoffTime}
                                </span>
                            </div>
                            </div>
                          </div>

                          <div className="bg-white p-4 rounded-lg shadow-sm">
                            <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
                              Pickup Location
                            </h4>
                            <div className="flex items-center">
                              <svg
                                className="w-4 h-4 text-indigo-500 mr-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                              </svg>
                              <span className="font-medium">
                                {bookingDetails.pickupLocation}
                              </span>
                            </div>
                          </div>

                          <div className="bg-white p-4 rounded-lg shadow-sm">
                            <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
                              Dropoff Location
                            </h4>
                            <div className="flex items-center">
                              <svg
                                className="w-4 h-4 text-indigo-500 mr-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                              </svg>
                              <span className="font-medium">
                                {bookingDetails.dropoffLocation}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="mt-6 pt-6 border-t border-indigo-100 flex justify-between items-center">
                          <div>
                            <h4 className="text-sm font-medium text-gray-500 mb-1">
                              Total Estimate
                            </h4>
                            <p className="text-3xl font-bold text-indigo-600">
                              Rs. {calculateTotalPrice()}
                              <span className="text-base font-normal text-gray-500 ml-1">
                                ({new Date(bookingDetails.pickupDate).toLocaleDateString()} - {new Date(bookingDetails.dropoffDate).toLocaleDateString()})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Agreement Checkboxes */}
                      <div className="space-y-3 mb-6">
                        <label className="flex items-start">
                          <div className="flex items-center h-5">
                            <input
                              type="checkbox"
                              className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                              checked={agreeMarketing}
                              onChange={(e) =>
                                setAgreeMarketing(e.target.checked)
                              }
                            />
                          </div>
                          <div className="ml-3 text-sm">
                            <p className="text-gray-700">
                              I agree with sending marketing and newsletter
                              emails. No spam, promised!
                            </p>
                          </div>
                        </label>

                        <label className="flex items-start">
                          <div className="flex items-center h-5">
                            <input
                              type="checkbox"
                              className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                              checked={agreeTerms}
                              onChange={(e) => setAgreeTerms(e.target.checked)}
                            />
                          </div>
                          <div className="ml-3 text-sm">
                            <p className="text-gray-700">
                              I agree with our{" "}
                              <button
                                type="button"
                                onClick={handleLinkClick}
                                className="text-blue-600 hover:underline"
                              >
                                terms and conditions
                              </button>{" "}
                              and{" "}
                              <button
                                type="button"
                                onClick={handleLinkClick}
                                className="text-blue-600 hover:underline"
                              >
                                privacy policy
                              </button>
                              .
                            </p>
                          </div>
                        </label>
                      </div>

                      {/* Security Info */}
                      <div className="flex items-start p-4 bg-blue-50 rounded-lg">
                        <div className="flex-shrink-0 mt-1">
                          <svg
                            className="h-5 w-5 text-blue-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-blue-800">
                            Secure Payment
                          </h3>
                          <p className="text-sm text-blue-700 mt-1">
                            All your data is protected with bank-level security.
                            We use 256-bit SSL encryption to ensure your
                            information is safe.
                          </p>
                        </div>
                      </div>

                      {/* Submit Button */}
                      <button
                        onClick={handleSubmit}
                        className="mt-6 w-full bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white py-3 rounded-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
                      >
                        Confirm & Book Now
                      </button>
                    </div>
                  </div>
                )}

                {/* Step 4: Success */}
                {currentForm === 4 && bookingSuccess && (
                  <div className="text-center py-10">
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                      <svg
                        className="h-10 w-10 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <h2 className="mt-4 text-2xl font-bold text-gray-900">
                      Booking Confirmed!
                    </h2>
                    <p className="mt-2 text-gray-600 max-w-md mx-auto">
                      Your car rental has been successfully booked. We've sent a
                      confirmation to your email with all the details.
                    </p>
                    <div className="mt-8 bg-gray-50 p-6 rounded-lg">
                      <h3 className="text-lg font-medium text-gray-900">
                        What's Next?
                      </h3>
                      <ul className="mt-4 space-y-3 text-sm text-gray-600">
                        <li className="flex items-start">
                          <svg
                            className="flex-shrink-0 h-5 w-5 text-green-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="ml-2">
                            You'll receive a confirmation email shortly
                          </span>
                        </li>
                        <li className="flex items-start">
                          <svg
                            className="flex-shrink-0 h-5 w-5 text-green-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="ml-2">
                            Our team will contact you to finalize details
                          </span>
                        </li>
                        <li className="flex items-start">
                          <svg
                            className="flex-shrink-0 h-5 w-5 text-green-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="ml-2">
                            Prepare your driver's license for pickup
                          </span>
                        </li>
                      </ul>
                    </div>
                    <button
                      onClick={() => navigate('/userpage')}
                      className="mt-8 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Back to Home
                      <svg
                        className="ml-2 -mr-1 w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>

              {/* Navigation Buttons */}
              {currentForm !== 4 && (
                <div className="px-8 py-4 bg-gray-50 border-t flex justify-between">
                  <button
                    onClick={handlePrevious}
                    className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <svg
                      className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Previous
                  </button>
                  {currentForm < 3 && (
                    <button
                      onClick={handleNext}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Next
                      <svg
                        className="-mr-1 ml-2 h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default DetailPage;